import type { PartialDispensaryForGcvAdmin } from '@gcv/shared';
import { useQuery } from '@tanstack/react-query';

import { DispensariesApi } from 'api';
import { ALL_DISPENSARIES_KEY } from 'tanstack-hooks/keys';

export function useAllDispensaries(enabled: boolean) {
  const dispensariesApi = new DispensariesApi();

  const { data: dispensaries, isLoading: isLoadingDispensaries } = useQuery<PartialDispensaryForGcvAdmin[]>({
    enabled,
    queryKey: [ALL_DISPENSARIES_KEY],
    queryFn: () => dispensariesApi.getAllDispensaries()
  });

  return { dispensaries: dispensaries ?? [], isLoadingDispensaries };
}
